import { useCallback, useEffect, useState } from 'react';
import { SrcsCache } from './helpers';
export const useSrcWithFallback = ({ srcs, setHasError }) => {
    const [loading, setLoading] = useState(false);
    const [srcWithFallback, setSrcWithFallback] = useState();
    const findFirstValidUrl = useCallback(async () => {
        const handleError = () => {
            setSrcWithFallback(undefined);
            setLoading(false);
            setHasError(true);
        };
        const cachedValue = SrcsCache.getInstance().get(srcs);
        if (cachedValue === null || !srcs?.length) {
            handleError();
            return;
        }
        if (cachedValue) {
            setHasError(false);
            setSrcWithFallback(cachedValue);
            return;
        }
        setLoading(true);
        for (const url of srcs) {
            const handleSuccess = () => {
                SrcsCache.getInstance().set(srcs, url);
                setLoading(false);
                setHasError(false);
                setSrcWithFallback(url);
            };
            const img = new Image();
            img.src = url;
            if (img.complete)
                handleSuccess();
            const urlExists = await new Promise((resolve) => {
                img.onload = () => {
                    handleSuccess();
                    resolve(true);
                };
                img.onerror = () => {
                    resolve(false);
                };
            });
            if (urlExists)
                return;
        }
        handleError();
        SrcsCache.getInstance().set(srcs, null);
    }, [srcs, setLoading, setHasError, setSrcWithFallback]);
    useEffect(() => {
        void findFirstValidUrl();
    }, [srcs, findFirstValidUrl]);
    return { srcWithFallback, loading };
};
